export default {
  //我的消息列表
  tidingsList : '/index/Tidings/index',
  //我的消息详情
  tidingsDetail : '/index/Tidings/detail',
  //我的消息详情
  tidingsReply : '/index/Tidings/reply',
  //我的订单列表
  orderList : '/index/Orders/index',
  //系统公告
  noticeList : '/index/Message/index',
  //系统详情
  noticeDetail : '/index/Message/detail',
  //报名信息列表
  resumeList : '/index/Resume/index',
  //报名信息添加
  resumeAdd : '/index/Resume/add',
  //获取登录验证码
  getCaptcha : '/index/login/getCaptcha',
  //登录
  login : '/index/login/login',
  //获取验证码
  sendSms : '/index/login/captcha_phone',
  //验证码登录
  loginPhone : '/index/login/login_phone',
  //注册
  reg : '/index/login/reg',
  //修改密码获取验证码
  send_captcha : 'index/login/send_captcha',
  //修改密码
  modpass : 'index/login/modpass',
  //查询报名信息列表
  examList : 'index/Exam/index',
  //报名信息表查询
  SignupList : 'index/Signup/index',
  //报名信息表查询
  SignupAdd : 'index/Signup/add',
  //报名进度
  progress : 'index/Exam/progress',
  //取消报名
  cancel : 'index/Exam/cancel',
  //免费支付
  pay_free : 'index/pay/pay_free',
  //微信支付
  pay_wxpay : 'index/pay/pay_wxpay',
  //个人资料修改
  userEdit : 'index/user/edit',
  //配置查询
  siteSettingsConfig : '/index/config/index',
  //支付宝支付
  pay_alipay : 'index/pay/pay_free',
  //模板样式
  tempShow : 'index/Exam/tempShow',
}



// WEBPACK FOOTER //
// ./src/api.js